export enum FIELDS_BASE_PATHS {
  PAGE_RESULTS_SETTINGS = 'results-settings',
  FIELDS_DEFINITIONS = 'fields',
  FIELD_VALUES = 'field-values',
  FIELD_TYPES = 'field-types',
}
